<app-modal
  [title]="'sendEmail' | translate"
  [submitText]="'send' | translate"
  [cancelText]="'cancel' | translate"
  (handleOnSubmit)="sendEmail()"
  [disabledSubmit]="!emailForm.valid || !to.value"
>
  <div class="send-email">
    <form [formGroup]="emailForm">
      <div class="form-group row">
        <div class="col-12 col-sm-12 col-md-4 col-lg-3">
          <span>{{ 'emailTo' | translate }} <span class="text-danger">*</span></span>
        </div>
        <div class="col-12 col-sm-12 col-md-8 col-lg-9">
          <tag-input
            formControlName="to"
            name="to"
            [theme]="'regular-theme'"
            [addOnBlur]="true"
            [onAdding]="addEmailTag"
            [validators]="validators"
            [errorMessages]="errorMessages"
            [separatorKeyCodes]="[13, 32, 186]"
          >
          </tag-input>
        </div>
      </div>
      <div class="form-group row">
        <div class="col-12 col-sm-12 col-md-4 col-lg-3">
          <span>{{ 'emailCC' | translate }}</span>
        </div>
        <div class="col-12 col-sm-12 col-md-8 col-lg-9">
          <tag-input
            formControlName="cc"
            name="cc"
            [theme]="'regular-theme'"
            [addOnBlur]="true"
            [onAdding]="addEmailTag"
            [validators]="validators"
            [errorMessages]="errorMessages"
            [separatorKeyCodes]="[13, 32, 186]"
          >
          </tag-input>
        </div>
      </div>
      <div class="form-group row">
        <div class="col-12 col-sm-12 col-md-4 col-lg-3">
          <span>{{ 'emailSubject' | translate }} <span class="text-danger">*</span></span>
        </div>
        <div class="col-12 col-sm-12 col-md-8 col-lg-9">
          <input formControlName="subject" class="form-control" type="text" name="subject" />
        </div>
      </div>
      <div class="form-group row">
        <div class="col-12 col-sm-12 col-md-8 col-lg-9 offset-md-4 offset-lg-3">
          <input
            formControlName="tempAttachFile"
            type="file"
            class="form-control d-none"
            #file
            multiple
            [accept]="acceptFileType"
            (change)="addFileAttachment($event.target.files)"
          />
          <div class="attach-file-group">
            <div *ngFor="let file of attachFile.value" class="attach-file">
              <span class="attach-file-text"
                >{{ file.name }}&nbsp;
                <i class="fa fa-times pointer" aria-hidden="true" (click)="removeFileAttachment(file)"></i>
              </span>
            </div>
          </div>
          <button class="btn btn-link btn-sm attach-btn" (click)="file.click()" style="text-transform: unset;">
            <i class="fa fa-plus" aria-hidden="true"></i>&nbsp;
            <span>{{ 'attachFiles' | translate }}</span>
          </button>
        </div>
      </div>
      <div class="form-group">
        <span>{{ 'emailContent' | translate }}</span>
      </div>
      <div class="form-group">
        <ngx-editor-menu [editor]="editor" [toolbar]="toolbar">
				</ngx-editor-menu>
        <ngx-editor
          [editor]="editor"
          [placeholder]="'emailContentPlaceholder' | translate"
          formControlName="content"
        ></ngx-editor>
      </div>
      <div class="error-message-container">
        <app-control-message [message]="backendErrorMessage"></app-control-message>
      </div>
    </form>
  </div>
</app-modal>
<ngx-loading [show]="isLoading"></ngx-loading>
